import React from "react";
import { Link } from "react-router-dom";

export const Header = (props) => {
  const data = props.data || {};
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-10 col-md-offset-1 intro-text">
                <span className="eyebrow">{data.subtitle}</span>
                <h1>{data.title || "Loading"}</h1>
                <p>{data.paragraph}</p>
                <Link to="/products" className="btn btn-custom btn-lg">
                  View Our Products
                </Link>{" "}
                <Link to="/contact" className="btn btn-ghost btn-lg">
                  Request a Quote
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
